export const environment = {
  mock: false,
  production: true,
  development: false,
  title: 'dev',
  base_config: '/config/APP/app.config.json',
  i18nResourceLocation: 'assets/i18n/',
  version: require('../../package.json').version
};
